import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const todayLink = this.element.querySelector(".today-link")
    if (todayLink) {
      const parentDiv = todayLink.closest("div")
      if (parentDiv) {
        parentDiv.classList.add("bg-gray-200")
      }
    }
  }
}
